var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriorityLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67453 7.71312C5.86178 7.87362 6.13808 7.87362 6.32532 7.71312L10.992 3.71312C11.2017 3.53341 11.2259 3.21776 11.0462 3.0081C10.8665 2.79844 10.5509 2.77416 10.3412 2.95387L5.99993 6.67496L1.65866 2.95387C1.44899 2.77416 1.13334 2.79844 0.953633 3.0081C0.773922 3.21776 0.798202 3.53341 1.00787 3.71312L5.67453 7.71312ZM1.00787 1.04646L5.67453 5.04646C5.86178 5.20695 6.13808 5.20695 6.32532 5.04646L10.992 1.04646C11.2017 0.866747 11.2259 0.551097 11.0462 0.341434C10.8665 0.131772 10.5509 0.107491 10.3412 0.287201L5.99993 4.00829L1.65866 0.287201C1.44899 0.107491 1.13334 0.131772 0.953633 0.341434C0.773922 0.551097 0.798202 0.866747 1.00787 1.04646Z",
    fill: "#00B670"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityLow);
export default __webpack_public_path__ + "static/media/priority-low.b37306d820709057756227e7cd473447.svg";
export { ForwardRef as ReactComponent };